var map = {
	"./activity-calendar/activity-calendar.module": [
		"../../../../../src/app/activity-calendar/activity-calendar.module.ts",
		"activity-calendar.module",
		"common"
	],
	"./analytics/analytics.module": [
		"../../../../../src/app/analytics/analytics.module.ts",
		"common",
		"analytics.module"
	],
	"./auth/auth.module": [
		"../../../../../src/app/auth/auth.module.ts",
		"common",
		"auth.module"
	],
	"./notifications/notifications.module": [
		"../../../../../src/app/notifications/notifications.module.ts",
		"common",
		"notifications.module"
	],
	"./products/products.module": [
		"../../../../../src/app/products/products.module.ts",
		"common",
		"products.module"
	],
	"./settings/settings.module": [
		"../../../../../src/app/settings/settings.module.ts",
		"common",
		"settings.module"
	],
	"./users/users.module": [
		"../../../../../src/app/users/users.module.ts",
		"common",
		"users.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/roche/roche/src/$$_gendir lazy
// module id = ../../../../../src/$$_gendir lazy recursive
// module chunks = main